exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.actividadPreparacion .estilo-grilla,\r\n.actividadPreparacion #gridComponent {\r\n  height: auto !important;\r\n  margin-bottom: 50px;\n}\r\n", ""]);

// exports
